import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Large Grid-Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center" }, [
                    _createElementVNode("p", null, "col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<div class=\"row\">\n<div class=\"col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center\">\n<p>col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12</p>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4 pb-0" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Mid Grid-Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6")
                  ])
                ]),
                _createElementVNode("div", { class: "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<div class=\"row\">\n<div class=\"col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center\">\n<p>col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6</p>\n</div>\n</div>\n<div class=\"col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center\">\n<p>col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6</p>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4 pb-0" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Three Grid-Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4")
                  ])
                ]),
                _createElementVNode("div", { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4")
                  ])
                ]),
                _createElementVNode("div", { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-primary text-white py-2 px-3\">Primary</button>\n<button type=\"button\" class=\"btn btn-primary text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Primary</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-secondary text-white py-2 px-3\">Secondary</button>\n<button type=\"button\" class=\"btn btn-secondary text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Primary</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-success text-white py-2 px-3\">Success</button>\n<button type=\"button\" class=\"btn btn-success text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Success</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-info text-white py-2 px-3\">Info</button>\n<button type=\"button\" class=\"btn btn-info text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Info</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-warning text-white py-2 px-3\">Warning</button>\n<button type=\"button\" class=\"btn btn-warning text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Warning</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-danger text-white py-2 px-3\">Danger</button>\n<button type=\"button\" class=\"btn btn-danger text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Danger</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-dark text-white py-2 px-3\">Dark</button>\n<button type=\"button\" class=\"btn btn-dark text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Dark</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"mt-2 me-2 d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-light text-white py-2 px-3\">Light</button>\n<button type=\"button\" class=\"btn btn-light text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Light</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4 pb-0" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Four Grid-Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3")
                  ])
                ]),
                _createElementVNode("div", { class: "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3")
                  ])
                ]),
                _createElementVNode("div", { class: "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3")
                  ])
                ]),
                _createElementVNode("div", { class: "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<div class=\"row\">\n<div class=\"col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4\">\n<p>col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3</p>\n</div>\n</div>\n<div class=\"col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4\">\n<p>col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3</p>\n</div>\n</div>\n<div class=\"col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4\">\n<p>col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3</p>\n</div>\n</div>\n<div class=\"col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3\">\n<div class=\"bg-primary bg-opacity-10 p-5 rounded-3 text-center mb-4\">\n<p>col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3</p>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4 pb-0" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Twelve Grid-Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ]),
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("div", { class: "bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4" }, [
                    _createElementVNode("p", null, "col")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<div class=\"row\">\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n<div class=\"col\">\n<div class=\"bg-primary bg-opacity-10 p-3 rounded-3 text-center mb-4\">\n<p>col</p>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}